<template>
	<div class="container">
		<div class="row">
			<season-vertical-component v-for="season in seasons.data" :season="season" :key="season.id"></season-vertical-component>
		</div>
		<div class="row text-center">
			<paginate-component v-bind="seasons"></paginate-component>
		</div>
	</div>
</template>
<script>
'use strict';
export default {
	name: 'years-show',
	data() {
		return {
			seasons: {}
		};
	},
	methods: {
		getSeasons() {
			window.api.seasons.index({
				years: this.$route.params.slug
			}, (paginate) => {
				window.Vue.set(this, 'seasons', paginate);
			});
		}
	},
	watch: {
		$route(){
			this.getSeasons();
		},
	},
	created() {
		this.getSeasons();
	},
};

</script>
<style lang="css" scoped>


</style>
